import { App } from '@inertiajs/inertia-react';
import React from 'react';
import { render } from 'react-dom';
import 'semantic-ui-css/semantic.min.css';
import { InertiaProgress } from '@inertiajs/progress';
import AuthLayout from "./Shared/Layout";

InertiaProgress.init();

const el = document.getElementById('app');

render(
    <App
        initialPage={JSON.parse(el.dataset.page)}
        resolveComponent={(name) => import(`./Pages/${name}`).then(({ default: page }) => {
            if (page.layout === undefined) {
                page.layout = AuthLayout
            }
            return page
        })}
    />,
    el
);
